import { ca } from '@cian/analytics';

export function trackClose() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'close',
  });
}

export function trackShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'show',
  });
}
